"use client";

import { track } from "@vercel/analytics";

export default function AnalyticsTracker({
  children,
  eventName,
  eventProperties,
  className,
}: {
  children: React.ReactNode;
  eventName: string;
  eventProperties: Record<string, any>;
  className?: string;
}) {
  const handleClick = () => {
    track(eventName, eventProperties);
  };

  return <div onClick={handleClick} className={className}>{children}</div>;
}
